import { memo, useCallback, useContext, useMemo } from 'react';
import { intentPropTypes } from 'common/propTypes';
import { INTENT_TYPES, REFERENCE_LIST } from 'v2/common/constants/index';
import { IntentsContext } from 'v2/modules/withRunForm/hoc/withIntentsContext';
import HoverMessage from 'common/components/HoverMessage';
import ModifyExistingLegsIntent from './ModifyExistingLegsIntent/index';
import OpenOrCloseExistingCase from './OpenOrCloseExistingCase';
import OpenLegIntent from './OpenLegIntent/index';
import BasketIntent from './BasketIntent/index';
import classNames from 'classnames';
import { referenceTracker } from 'v3/quantConfig/reference/referenceTracker';

const propTypes = {
  intent: intentPropTypes.isRequired,
};

const defaultProps = {};

const Intent = ({ intent }) => {
  const {
    onDeleteIntent,
  } = useContext(IntentsContext);

  const handleDeleteIntent = useCallback(() => {
    const { identifier: { label: indentIndex } } = intent;
    const intentEntity = {
      type: REFERENCE_LIST.intent,
      index: indentIndex,
      details: intent
    };
    referenceTracker.performDeleteOrShowWarning( intentEntity, () => onDeleteIntent(indentIndex));
  }, [intent, onDeleteIntent]);

  const renderDeleteBtn = useMemo(() => (
    <HoverMessage
      message="Delete"
      popClassName="d-sm-none d-md-block custom-popover"
    >
      <button
        className="delete-button btn btn-outline-secondary me-2"
        type="button"
        onClick={handleDeleteIntent}
      >
        <i className="fa-regular fa-trash-can"></i>
      </button>
    </HoverMessage>
  ), [intent.identifier.label, handleDeleteIntent]);

  const parentDivClassName = classNames('leg-label-ribbon');

  const IntentComponent = useMemo(() => {
    switch (intent.type) {
      case INTENT_TYPES.CloseLeg:
      case INTENT_TYPES.UpdateStopLoss:
        return ModifyExistingLegsIntent;

      case INTENT_TYPES.OpenBasket:
        return BasketIntent;
      
      case INTENT_TYPES.OpenCase:
      case INTENT_TYPES.CloseCase:
        return OpenOrCloseExistingCase;

      default:
        return OpenLegIntent;
    }
  }, [intent.type]);

  return (
    <>
      { INTENT_TYPES[intent.type] !== INTENT_TYPES.OpenBasket && 
      <span className={parentDivClassName}>
        <div className="wrapper">
          <div className="badge">
            Leg
            {' '}
            {intent?.identifier?.label}
          </div>
        </div>
      </span>}
      <IntentComponent intent={intent} renderDeleteBtn={renderDeleteBtn} />
    </>
  );
};

Intent.propTypes = propTypes;
Intent.defaultProps = defaultProps;

export default memo(Intent);
